exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MesseApp{position:relative;width:100%;min-height:500px;color:#000000}.MesseApp img{width:auto;height:auto}\n", ""]);
